/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { or } from '@ember/object/computed';
import Component from '@ember/component';
import { isNone } from '@ember/utils';

import { CUSTOMER_TIME_ZONE } from 'cio/utils/time-zones';

import { task } from 'ember-concurrency';
import { VWB_ACTION_UPDATED } from 'cio/services/event-bus';

@tagName('')
export default class TimeWindow extends Component {
  @service apiErrors;
  @service actionSubjects;
  @service environment;
  @service eventBus;
  @service visualWorkflowBuilder;

  actionAbstract = null;
  isAddingOrMoving = false;
  onSelect() {}
  onDeselect() {}
  onDeleteStarted() {}
  onDeleteConfirmed() {}

  @or('_saveWindow.isRunning', '_confirmSave.isRunning') _isSaving;

  _showConfirmModal = false;
  _hasUsedTimeZoneMatch = false;

  @computed('actionAbstract.zone')
  get _isCustomerTimeZoneSelected() {
    return this.get('actionAbstract.zone') === CUSTOMER_TIME_ZONE.value;
  }

  init() {
    super.init(...arguments);

    let hasUsedTimeZoneMatch = localStorage.getItem(this._timeZoneMatchLSKey());
    if (!isNone(hasUsedTimeZoneMatch)) {
      this.set('_hasUsedTimeZoneMatch', JSON.parse(hasUsedTimeZoneMatch));
    }
  }

  @computed('actionAbstract.action.id')
  get _subjects() {
    return this.actionSubjects.find(this.get('actionAbstract.action.id'));
  }

  timeZoneMatchLSBaseKey = 'cio:time-zone-match';

  _timeZoneMatchLSKey() {
    let key = this.get('timeZoneMatchLSBaseKey');
    let environmentId = this.get('environment.current.id');

    return `${key}:env-${environmentId}`;
  }

  _saveWindow = task(
    {
      drop: true,
    },
    async () => {
      if (this.get('actionAbstract.illegalFallbackZoneSelected')) {
        this.set('_illegalFallbackZoneAttemptedSave', true);
      } else if (this.get('_isCustomerTimeZoneSelected') && !this.get('_hasUsedTimeZoneMatch')) {
        this.set('_showTimeZoneMatchModal', true);
      } else {
        let hasSubjects = this.get('_subjects.count') > 0;

        if (hasSubjects) {
          this.set('_showConfirmModal', true);
        } else {
          await this._confirmSave.perform();
        }
      }
    },
  );

  _confirmTimeZoneMatch = task(
    {
      drop: true,
    },
    async () => {
      localStorage.setItem(this._timeZoneMatchLSKey(), JSON.stringify(true));
      this.setProperties({
        _hasUsedTimeZoneMatch: true,
        _showTimeZoneMatchModal: false,
      });

      await this._saveWindow.perform();
    },
  );

  _confirmSave = task(
    {
      drop: true,
    },
    async () => {
      this.set('_showConfirmModal', false);

      try {
        let promise = this.actionAbstract.saveTask.perform();
        this.visualWorkflowBuilder.redrawConnectingLines();
        await promise;
        this.eventBus.publish(VWB_ACTION_UPDATED, this.actionAbstract.action);
        this.onDeselect();
      } catch (e) {
        this.apiErrors.report(e);
        throw e;
      }
    },
  );

  _deleteWindow = task(
    {
      drop: true,
    },
    async () => {
      try {
        this.onDeleteConfirmed();
        await this.actionAbstract.deleteTask.perform();
        this.onDeselect();
      } catch (e) {
        this.apiErrors.report(e);
        throw e;
      }
    },
  );

  @action
  setConditions(conditions) {
    this.set('actionAbstract.preconditions', conditions);
  }
}
